import { capitalize } from '@gonfalon/strings/capitalize';

import { SuccessCriteriaDisplayOptions } from './constants';
import type { Metric } from './types';

export function getSuccessCriteriaDisplayName(successCriteria: Metric['successCriteria']): string {
  const option = SuccessCriteriaDisplayOptions.find((sc) => sc.value === successCriteria);
  return option ? capitalize(option.displayName) : 'undefined';
}
